// frontend/src/components/FinanceReport/Accounting/components/accounts/clients/requests.js
import { authFetch } from "../../../../../api/api";

const BASE_URL = (process.env.REACT_APP_DJANGO_BACKEND || "").replace(/\/+$/, "");
const RECORDS_URL = `${BASE_URL}/api/accounting/accounting-records/`;
const CLIENTS_URL = `${BASE_URL}/api/clients/`;

export async function getAllAccountingRecords() {
  const response = await authFetch(RECORDS_URL);
  if (!response.ok) throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  const data = await response.json();
  return Array.isArray(data) ? data : data.results || [];
}

export async function getAllClients() {
  const response = await authFetch(CLIENTS_URL);
  if (!response.ok) throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  const data = await response.json();
  return Array.isArray(data) ? data : data.results || [];
}